import { useEffect, useRef, useState } from "react";

const CANVAS_WIDTH = 3840;
const CANVAS_HEIGHT = 2160;

export function useCanvasScale() {
  const ref = useRef<HTMLElement | null>(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    function resize() {
      const width = window.innerWidth || CANVAS_WIDTH;
      const height = window.innerHeight || CANVAS_HEIGHT;
      setScale(Math.min(width / CANVAS_WIDTH, height / CANVAS_HEIGHT));
    }

    resize();
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  return { ref, scale };
}
